import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
} from "devextreme-react/data-grid";
import { buildDxFilters, FillFilters, FormatPhoneNumber, loadLookupFromDataSource, loadLookupFromStaticDataSource } from '../../../common/Utils'
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { TextBox } from 'devextreme-react';
import axios from 'axios';
import data from '../../../assets/apiRoutes.json'
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);
    const [resultData, setResultData] = useState(null);

    const gridKey = "5BAA61C5-5895-465A-90EC-AA9A621113E1";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);

    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const [TripNumber, setTripNumber] = useState('');
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].FMTRIPNUMBER;
            setIsEditButtonDisabled(false);
        }
        else {
            rowId.current = '';
            setIsEditButtonDisabled(true);
        }

    };

    const handelEditClick = () => {
        const buttonUrl = "/om/transactions/delivery-management/edit?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        loadDatasource(TripNumber);
    }
    const handleReset = (e) => {
        e.event.stopPropagation();
        setTripNumber('');
        loadDatasource('');
    }
    useEffect(() => {
        loadDatasource('');

    }, []);


    const loadDatasource = (tripNumber) => {
        axios.get(`${window._env_.REACT_APP_APIS}/${data.OM.GetTripStops}?tripNumber=${tripNumber}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                }
            })
            .then((result) => {
                setResultData(result.data);
            });
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        {/* <form style={{ width: "100%" }} onSubmit={(e) => onSearchTransaction(e)}> */}
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2
                                                }}
                                            >
                                                Enter Your Query For Update Route/Trips on Orders
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                </Toolbar>
                            )}
                            itemRender={(itemProps) => (
                                <div className="row">
                                    <div className="col-md-4">
                                <TextBox
                                    id="FMTRIPNUMBER"
                                    placeholder="Trip #"
                                    labelMode='static'
                                    stylingMode='outlined'
                                    value={TripNumber}
                                    onValueChanged={(e) => {
                                        setTripNumber(e.value);
                                    }}
                                />
                                    </div>
                                </div>
                            )}
                            id="accordion-container" className="accordion-height"
                        />

                        <DataGrid

                            onExporting={(e) => {
                                if (window.handleDevExtremeDataGridExport) {
                                    window.handleDevExtremeDataGridExport(e);
                                }
                            }}
                            ref={dataGrid}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            dataSource={resultData}
                            showBorders={true}
                            hoverStateEnabled={true}
                            className={searchPanelStatus ? "GridHeightAccordianOpen" : "GridHeightAccordianClose"}
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            remoteOperations={true}
                            searchEnabled={true}
                            columnAutoWidth={true}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="single" />
                            <Sorting visible={true} mode="multiple" />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Paging enabled={false} />
                            <Column dataType="string" dataField="FMTRIPNUMBER" caption="Trip Number" />
                            <Column dataType="string" dataField="Stops" caption="Stops" />


                            <GridToolbar>
                                <GridToolbarItem location="before">
                                    <Button
                                        disabled={isEditButtonDisabled}
                                        onClick={handelEditClick}
                                        type="default"
                                        text="Edit"
                                    ></Button>
                                </GridToolbarItem>
                                <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                        </DataGrid>
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(List);